<form [formGroup]="form">
  <div class="filters-bar">
    @if (!this.warehouses.length) {
      {{ 'SHIPMENT_MANAGEMENT.NO_ASSIGNED_WAREHOUSE' | translate}}
    } @else {
      <div class="field warehouse-field">
        <mat-form-field appearance="outline" floatLabel="auto">
          <mat-label>{{ wareHouseTypeLabel | translate}}</mat-label>
          <input matInput 
                formControlName="warehouse" 
                [matAutocomplete]="autoWarehouse"
                (click)="onWarehouseClick()"
                placeholder="{{ 'SHIPMENT_MANAGEMENT.SELECT_WAREHOUSE' | translate }}" />
          <mat-icon matSuffix (click)="onWarehouseClick()">arrow_drop_down</mat-icon>
          <mat-autocomplete #autoWarehouse="matAutocomplete" [displayWith]="warehouseDisplayFn">
            <mat-option *ngFor="let warehouse of wareHouses$ | async; let i = index" [value]="warehouse">
              {{warehouse.friendlyName}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    }
  </div>
</form>